module.exports = __webpack_public_path__ + "static/media/gatsbyjs.a098870e.svg";